(function() {
    'use strict';

    function initVideoFallback() {
        const video = document.querySelector('.hero__video');

        if (!video) return;

        // Falls das Video schon spielt (z.B. aus dem Cache), sofort einblenden
        if (!video.paused) {
            video.classList.remove('opacity-0');
            return;
        }

        video.addEventListener('playing', function() {
            video.classList.remove('opacity-0');
        }, { once: true });
    }

    function init() {
        const heroImages = document.querySelectorAll('.hero__background');

        if (heroImages.length <= 1) return;

        let currentIndex = 0;
        const intervalTime = 5000; // 5 Sekunden

        function switchImage() {
            // Aktuelles Bild ausblenden
            heroImages[currentIndex].classList.remove('hero__background--active');
            heroImages[currentIndex].classList.remove('opacity-100');
            heroImages[currentIndex].classList.add('opacity-0');

            // Nächsten Index berechnen (zurück zu 0 nach dem letzten Bild)
            currentIndex = (currentIndex + 1) % heroImages.length;

            // Nächstes Bild einblenden
            heroImages[currentIndex].classList.add('hero__background--active');
            heroImages[currentIndex].classList.remove('opacity-0');
            heroImages[currentIndex].classList.add('opacity-100');
        }

        // Bildwechsel alle 5 Sekunden
        setInterval(switchImage, intervalTime);
    }

    document.addEventListener('DOMContentLoaded', function() {
        initVideoFallback();
        init();
    });

})();